import React, { createContext, useReducer, useContext } from "react";
import ModalWrapper from "./ModalWrapper";
import ModalWrapperReducer from "./ModalWrapperReducer";

const HIDE_MODAL = 0
const SHOW_MODAL = 1

const ModalWrapperContext = createContext();
const initialState = {
    show: false
};

export function ModalWrapperProvider({ children }) {
    const hook = useProviderModalWrapper();
    return <ModalWrapperContext.Provider value={hook}>
        {children}
        <ModalWrapper />
    </ModalWrapperContext.Provider>;
}

export const useModalWrapper = () => {
    return useContext(ModalWrapperContext);
};

function useProviderModalWrapper() {
    const [state, dispatch] = useReducer(ModalWrapperReducer, initialState);

    return {
        modal: state,
        hideModal: () => {
            dispatch({
                type: HIDE_MODAL,
                payload: {}
            });
        },
        showModal: (props) => {
            dispatch({
                type: SHOW_MODAL,
                payload: props
            });
        }
    };
};
